import { OfferRequest } from "@duffel/api/types";
import { NGSShelf } from ".";
import { NGSOfferRow } from "./group-offers-for-ngs-view";

export type SortDirection = "asc" | "desc";

export const getCheapestOfferAmount = (
  offers: OfferRequest["offers"] | null,
) => (offers ? Math.min(...offers.map((offer) => +offer.total_amount)) : null);

export const sortNGSRowsByShelfPrice = (
  rows: NGSOfferRow[],
  sortShelf: NGSShelf,
  sortDirection: SortDirection,
): NGSOfferRow[] => {
  const sortedRows = [...rows].sort((a, b) => {
    const aAmount = +(getCheapestOfferAmount(a[sortShelf!]) || 0);
    const bAmount = +(getCheapestOfferAmount(b[sortShelf!]) || 0);
    if (aAmount && bAmount) {
      return sortDirection === "asc" ? aAmount - bAmount : bAmount - aAmount;
    }
    if (aAmount) return -1;
    if (bAmount) return 1;
    return 0;
  });

  return sortedRows;
};
;
import "/Users/igordepaula/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";